<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 1/9/2020
  -->

<template>
	<div class="mt-5">
		<hr/>
		<div class="qw-row p-2">
			<slot name="menuOptionsLeft"></slot>

			<div class="col"/>
			<i v-if="formElement.showCopy" class="button-circle fontello icon-docs font-size-5" @click="onCopyClicked"/>
			<i v-if="formElement.showDelete" class="button-circle fontello icon-trash font-size-5" @click="onDeleteClicked"/>
			<el-divider v-if="!hideRequired" direction="vertical"></el-divider>
			<div class="row align-items-center mx-0" v-if="!hideRequired">
				<span class="mx-2">Required</span>
				<el-switch v-model="formElement.isRequired" @change="onRequiredChanged"/>
			</div>
<!--			<el-divider v-if="!hideDescription" direction="vertical"></el-divider>-->
<!--			<div class="row align-items-center mx-0" v-if="!hideDescription">-->
<!--				<span class="mx-2">Show Description</span>-->
<!--				<el-switch v-model="formElement.showDescription" @change="onRequiredChanged"/>-->
<!--			</div>-->
		</div>
	</div>
</template>

<script>

import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";

export default {
	name: "FormElementMenu",
	components: {ToolTipView},
	props:{
		formElement: null,
		hideRequired: Boolean,
		hideDescription: Boolean
	},

	methods:{
		onRequiredChanged(){
			this.$emit("onRequiredChanged")
		},
		onChange(){
			this.$emit("change")
		},
		onCopyClicked(){
			this.$emit("copy")
		},
		onDeleteClicked(){
			this.$emit("delete")
		},
		onDescriptionVisibleClicked(){
			this.$emit("descriptionVisibilityToggle")
		},

	},

	computed: {
	},
}
</script>

<style>

</style>
